import styled from 'styled-components';

export const Header = styled.header`
  min-height: 10.6rem;
  background: #242424;
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 5.8rem;

  @media (max-width: 768px) {
    padding: 0 2rem;
  }
`;

export const HeaderWrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
`;

export const HeaderLabel = styled.span`
  font-size: 2.5rem;
  color: #ffdf22;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1.25px;
  margin-left: 0.6rem;
`;

export const SaveButton = styled.button`
  width: 31.7rem;
  height: 4.4rem;
  background: transparent linear-gradient(97deg, #ffdf22 0%, #ffd503 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 5rem;

  font-size: 1.8rem;
  font-weight: bold;
`;

interface CheckboxProps {
  isFilled: boolean;
}

export const Checkbox = styled.div<CheckboxProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  background: #fff;

  border: 0.8px solid #000000;
  border-radius: 0.4rem;

  height: 2.8rem;
  min-width: 2.8rem;

  margin-right: 0.8rem;

  .filled {
    background: ${({ theme, isFilled }) =>
      isFilled ? theme.colors.black : theme.colors.white};

    height: 2.2rem;
    min-width: 2.2rem;

    border-radius: inherit;

    transition: 180ms ease-in;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;

  margin-bottom: 0.8rem;

  cursor: pointer;

  &:hover {
    ${Checkbox} {
      .filled {
        background: #000;
      }
    }
  }
`;

export const Container = styled.div`
  padding: 3.6rem 3.1rem;

  form {
    display: grid;
    grid-template-columns: 1fr;
    max-width: 68.4rem;

    fieldset {
      border: none;
      padding-bottom: 2.8rem;

      div {
        border-radius: 2rem;
      }

      label {
        color: white;
        width: fit-content;
        display: block;
        margin-bottom: 0.5rem;
        margin-left: 1.7rem;
        font-weight: bold;
        font-size: 1.5rem;
      }

      .select-container {
        max-height: 3.5rem;
        div {
          border-radius: 2rem;
        }
      }

      .text-area-container {
        height: 100%;

        div {
          border-radius: 1rem;
          padding: 2rem;
          height: calc(100% - 2.8rem);

          textarea {
            font-size: 1.5rem;

            ::-webkit-scrollbar {
              width: 1rem;
              right: 5rem;
            }

            ::-webkit-scrollbar-track {
              background: #e9e9e9;
            }

            ::-webkit-scrollbar-thumb {
              background-color: #000;
              border-radius: 20px;
              border: 2px solid #e9e9e9;
            }
          }
        }
      }
    }

    .hide-fieldset {
      display: none;
    }

    .double-input {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 2.8rem 4.4rem;

      @media (max-width: 425px) {
        grid-template-columns: 1fr;
        gap: 0;
      }
    }

    .field-hover {
      transition: 0.2s;
      cursor: pointer;

      :hover {
        filter: brightness(0.9);
      }
    }
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;

  background: #ffffff80;

  margin-bottom: 2.8rem;
`;

export const PrincipleModalContainer = styled.div`
  h1 {
    text-align: center;
  }
  .container {
    margin: 3rem 0;
  }
`;
